import ApplicationController from '../application_controller';

class ContentDemandLoader extends ApplicationController {
  static targets = ['loader', 'content']

  connect() {
  }

  clearContent() {
    this.contentTarget.innerHTML = '';
    this.loaderTarget.style.display = '';
  }

  fetchContent(path) {
    fetch(path)
      .then(response => {
        if (!response.ok) throw new Error(response.statusText);
        return response.text()
      })
      .then(html => {
        this.loaderTarget.style.display = 'none';
        this.contentTarget.innerHTML = html;
      })
      .catch((err) => {
        this.handleError(err);
        this.loaderTarget.style.display = 'none';
        this.contentTarget.innerHTML = '<div class="error">Failed to load content.</div>';
      });
  }
}

export default ContentDemandLoader;
